import { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
  Button,
  CircularProgress,
  InputBase,
  Pagination,
  TableBody,
  Menu,MenuItem
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CustomText, { textStyles } from "../../../../components/CustomText";
import tablefilter from "../../../../assets/tablefilter.svg";
import { pdf } from "@react-pdf/renderer";
import eye from "../../../../assets/Wallet/eye.svg";
import WalletDetails from "./WalletDetails";
import RequestPayoutDrawer from "./RequestDrawer";
import FilterDrawer from "./FilterDrawer";
import MyWalletPDF from "./MyWalletPDF";
import StatusDropdown from "../../../../components/StatusDropdown";
import ExportDropdown from "../../../../components/ExportDropdown";
import VisibilityIcon from "@mui/icons-material/Visibility";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import emptyscreen from "../../../../assets/Dashboard/emptyscreen.svg";
import { useLocation } from 'react-router-dom';
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import emptypayment from "../../../../assets/emptypayment.png";
import { formatNumber } from "../../../../Utlis/formatNumber";
import ExportManagePayoutExcel from "./MyWalletExcel"
const ManagePayoutTable = () => {
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [tableProcessing, setTableProcessing] = useState(false);
  const [firstLoadDone, setFirstLoadDone] = useState(false);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortLoading, setSortLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [sortConfig, setSortConfig] = useState({ key: "paymentDate", direction: "desc" });
  const [totalRows, setTotalRows] = useState(0);
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [tableRows, setTableRows] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const location = useLocation();

 useEffect(() => {
  if (location.state?.openDrawer) {
    setOpenDrawer(true);
  }
}, [location.state]);

  // const [filters, setFilters] = useState({
  //   plan_name: [],
  //   commission_status: [],
  //   date_from: "",
  //   date_to: "",
  // });
const [filters, setFilters] = useState({
  commission_status: [],
  date_from: "",
  date_to: "",
});

const INITIAL_FILTERS = {
  commission_status: [],
  date_from: "",
  date_to: "",
};

//   const INITIAL_FILTERS = {
//      plan_name: [],
//     commission_status: [],
//     date_from: "",
//     date_to: "",
// };
// true if any filter set

const clearFilters = () => {
  setFilters(INITIAL_FILTERS);
  setPage(0); // reset pagination if needed
};
  const backendSortKeyMap = {
    id: "payout_id",
    companyName: "company_name",
    batchId: "paypal_batch_id",
    payoutAmount: "payout_amount",
    method: "method",
    paymentDate: "payout_date",
    email: "recipient_email",
    status: "payout_status",
  };

  const columns = [
    { key: "id", label: t("managePayout.id") },
    { key: "companyName", label: t("walletDetails.companyName") },
    { key: "batchId", label: t("walletDetails.paypalBatchId") },
    { key: "payoutAmount", label: t("managePayout.payout_amount") },
    { key: "method", label: t("managePayout.method") },
    { key: "paymentDate", label: t("managePayout.payment_date") },
    { key: "email", label: t("managePayout.email") },
    { key: "status", label: t("managePayout.status") },
    { key: "action", label: t("managePayout.action") },
  ];

  const handleSort = (key) => {
    // Disable the main loading and enable sort loading
    setLoading(false);
    setSortLoading(true);
    
    const newDirection = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key, direction: newDirection });
    setPage(0);
  };

  const fetchPayouts = useCallback(async () => {
    // Only set loading if we're not in a sort operation
     const isInitialLoad = !firstLoadDone;

  if (isInitialLoad) {
    setLoading(true);
  } else {
    setTableProcessing(true);
  }
    
    try {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page + 1);
      queryParams.append('limit', rowsPerPage);

if (filters.commission_status && filters.commission_status.length > 0) {
  queryParams.append('payout_status', filters.commission_status.join(','));
  console.log("🟢 Sending payout_status filter:", filters.commission_status.join(','));
}
if (filters.date_from) queryParams.append('date_from', filters.date_from);
if (filters.date_to) queryParams.append('date_to', filters.date_to);
      if (searchTerm) {
        queryParams.append('search', searchTerm);
      }

      const backendSortKey = backendSortKeyMap[sortConfig.key] || sortConfig.key;
      queryParams.append('sort_by', backendSortKey);
      queryParams.append('sort_order', sortConfig.direction);

      const res = await fetch(
        `${BASE_URL}/payments/account-exec/payout-history?${queryParams.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = await res.json();
 console.log("🟢 API Response Status:", res.status);
console.log("🟢 Full API Response:", result);

if (result?.data?.payouts) {
  console.log("🟢 Payouts received:", result.data.payouts.length);
  console.log("🟢 Sample payout record:", result.data.payouts[0]);
} else {
  console.warn("⚠️ No payouts array found in response structure:", result);
}
      const payouts = result?.data?.payouts || [];
      const formatted = payouts.map((item) => ({
        id: item.payout_id,
        commissionID: item.commission_id,
        batchId: item.paypal_batch_id,
        paypalTransactionId: item.paypal_transaction_id,
        paypalFee: item.paypal_fee,
        payoutStatus: item.payout_status,
        payoutDate: new Date(item.payout_date).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        companyName: item.company_name,
        planName: item.plan_name,
        commissionRate: item.commission_rate != null ? `${Math.round(item.commission_rate)}%` : "-",
        planAmount: ` ${item.plan_amount}`,
        payoutAmount: ` ${item.payout_amount}`,
        method: "Paypal",
        receipt: eye,
        paymentDate: new Date(item.payout_date).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        email: item.recipient_email || "-",
        status: item.payout_status,
        originalDate: new Date(item.payout_date)
      }));

      setOriginalData(formatted);
      setTableRows(formatted);
      setTotalRows(result?.data?.pagination?.total || 0);
    } catch (error) {
      console.error("Failed to fetch payout data:", error);
    } finally {
      setLoading(false);
    setTableProcessing(false);
    setFirstLoadDone(true);  
    }
  }, [page, rowsPerPage, filters, searchTerm, sortConfig, token, sortLoading]);
  // const isFilterApplied = Object.values(filters).some(f => f && f !== '');
  const isFilterApplied = Object.entries(filters).some(([key, value]) => {
  if (Array.isArray(value)) return value.length > 0;
  return value !== '';
});
  useEffect(() => {
    fetchPayouts();
  }, [fetchPayouts]);

  const HaederStyles = {
    color: "#44546F",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
  };

  const DataStyles = {
    color: "#172B4D",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    fontWeight: 400,
      whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
  };

  // const paginatedRows = tableRows;
  const filteredRows = tableRows.filter((row) =>
  Object.values(row).some(
    (val) =>
      val &&
      typeof val === "string" &&
      val.toLowerCase().includes(searchTerm.toLowerCase())
  )
)

const paginatedRows = filteredRows

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);

  // const handleApplyFilters = (appliedFilters) => {
  //   setFilters(appliedFilters);
  //   setFilterDrawerOpen(false);
  //   setPage(0);
  // };
  const handleApplyFilters = (appliedFilters) => {
  console.log("🟧 Received filters in parent:", appliedFilters);
  setFilters(appliedFilters);
  setFilterDrawerOpen(false);
  setPage(0);
};

  const handleClearAllFilters = (clearedFilters) => {
    setFilters(clearedFilters);
    setFilterDrawerOpen(false);
    setPage(0);
  };
// const paginatedRows = tableRows
// const totalPages = Math.ceil(totalRows / rowsPerPage)
const totalPages = Math.ceil(filteredRows.length / rowsPerPage);
const searchTimeout = useRef(null);
const handleSearchChange = (e) => {
  const value = e.target.value;
  clearTimeout(searchTimeout.current);
  searchTimeout.current = setTimeout(() => {
    setSearchTerm(value);
    setPage(0);
  }, 400); // 400ms debounce delay
};

const menuAnchorsRef = useRef({});
const [anchorEl, setAnchorEl] = useState(null);
const [menuRowId, setMenuRowId] = useState(null);
const selectedRowFromMenu = tableRows.find((r) => r.id === menuRowId);

  const statusButtonStyles = {
    Verified: { backgroundColor: "#2196F3", color: "#0D47A1" },
    Active: { backgroundColor: "#F5CD47", color: "#533F04" },
    Inactive: { backgroundColor: "#F87168", color: "#5D1F1A" },
    Blocked: { backgroundColor: "#579DFF", color: "#09326C" },
  }

  
  const fetchAllPayouts = async () => {
  const queryParams = new URLSearchParams();
  queryParams.append("no_pagination", "true");

  if (filters.plan_name && filters.plan_name.length > 0) {
    queryParams.append("plan_name", filters.plan_name.join(","));
  }
  if (filters.commission_status && filters.commission_status.length > 0) {
    queryParams.append("commission_status", filters.commission_status.join(","));
  }
  if (filters.date_from) queryParams.append("date_from", filters.date_from);
  if (filters.date_to) queryParams.append("date_to", filters.date_to);

  if (searchTerm) queryParams.append("search", searchTerm);

  const backendSortKey = backendSortKeyMap[sortConfig.key] || sortConfig.key;
  queryParams.append("sort_by", backendSortKey);
  queryParams.append("sort_order", sortConfig.direction);

  const res = await fetch(
    `${BASE_URL}/payments/account-exec/payout-history?${queryParams.toString()}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  const result = await res.json();

  const payouts = result?.data?.payouts || [];
  return payouts.map((item) => ({
    id: item.payout_id,
    commissionID: item.commission_id,
    batchId: item.paypal_batch_id,
    paypalTransactionId: item.paypal_transaction_id,
    paypalFee: item.paypal_fee,
    payoutStatus: item.payout_status,
    payoutDate: new Date(item.payout_date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
    companyName: item.company_name,
    planName: item.plan_name,
    commissionRate: item.commission_rate != null ? `${Math.round(item.commission_rate)}%` : "-",
    planAmount: ` ${item.plan_amount}`,
    payoutAmount: ` ${item.payout_amount}`,
    method: "Paypal",
    receipt: eye,
    paymentDate: new Date(item.payout_date).toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }),
    email: item.recipient_email || "-",
    status: item.payout_status,
    originalDate: new Date(item.payout_date),
  }));
};


  return (
    <Box sx={{ py: 2, px: 1 }} >
      <Box sx={{ backgroundColor: "#fff", borderRadius: 2, py: 2, border: "1px solid #E4E6EF" }}>



        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            px: 2,
            mb: 2,
            rowGap: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 600,
                fontSize: "18px",
                color: "#003149",
                textAlign: "left",
              }}
            >
              {t("managePayout.heading")}
            </CustomText>
            {/* Sort loader placed here, next to the title */}
         {tableProcessing && ( <CircularProgress size={16} sx={{ color: "#006EC2" }} />)}
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flexWrap: "wrap",
              flexGrow: 1,
              justifyContent:"flex-end",
            }}
          >
            {selected.length > 0 ? (
              ["Verified", "Active", "Inactive", "Blocked"].map((label) => (
                <Button
                  key={label}
                  variant="contained"
                  size="small"
                  sx={{
                    px: 2,
                    height: 34,
                    fontSize: 14,
                    fontWeight: 500,
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    backgroundColor: statusButtonStyles[label].backgroundColor,
                    color: statusButtonStyles[label].color,
                    "&:hover": {
                      backgroundColor: statusButtonStyles[label].backgroundColor,
                      opacity: 0.9,
                    },
                  }}
                  onClick={() => {
                    const updated = tableRows.map((row) =>
                      selected.includes(row.id) ? { ...row, status: label } : row,
                    )
                    setTableRows(updated)
                    setSelected([])
                  }}
                >
                  {t(`ClientsRequests.statusLabels.${label}`)}
                </Button>
              ))
            ) : (
              <>
           
            <Box
              sx={{
                px: 0.5,
                py: 0.2,
                borderRadius: 1,
                height: 34,
                border: "2px solid #091E4224",
                display: "flex",
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InputBase
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(0);
                }}         
                placeholder={t("commissionRecord.searchPlaceholder")}
                sx={{
                  ml: 0.5,
                  fontSize: 15,
                  letterSpacing: "1px",
                  color: "#939393",
                  fontWeight: 500,
                  width: "100%",
                }}
              />
              <SearchIcon sx={{ fontSize: 22, color: "#888", mr: 0.5 }} />
            </Box>
<ExportDropdown
  onDownloadPDF={async () => {
    const allData = await fetchAllPayouts(); // 👈 fetch full dataset
    const blobStream = pdf(<MyWalletPDF data={allData} />).toBlob();
    blobStream.then((blob) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `MyWallet_Report_${new Date().toISOString().slice(0,10)}.pdf`;
      link.click();
    });
  }}
  onDownloadExcel={async () => {
    const allData = await fetchAllPayouts(); // 👈 fetch full dataset
    ExportManagePayoutExcel(allData);
  }}
/>
                <Button
                  onClick={() => setOpenDrawer(true)}
                  variant="contained"
                  size="medium"
                  sx={{
                    px: 2,
                    backgroundColor: "#006EC2",
                    height: 32,
                    fontSize: 14,
                    fontWeight: 400,
                    fontFamily: "Poppins, sans-serif",
                    borderRadius: "4px",
                    textTransform: "none",
                  }}
                  startIcon={<AddIcon sx={{ fontSize: 18 }} />}
                >
                  {t("managePayout.details")}
                </Button>

      {isFilterApplied ? (
  <Box
    sx={{
      position: "relative",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: 34,
      height: 34,
      borderRadius: 1,
      bgcolor: "#006EC2", // blue background when filter applied
    }}
  >
    {/* Filter Icon */}
    <FilterAltIcon sx={{ color: "white", fontSize: 20 }} />

    {/* Small Cross Badge */}
    <IconButton
      size="small"
      onClick={clearFilters}
      sx={{
        position: "absolute",
        top: -6,
        right: -6,
        bgcolor: "white",
        width: 18,
        height: 18,
        border: "1px solid #C4C4C4",
        "&:hover": { bgcolor: "#f5f5f5" },
      }}
    >
      <CloseRoundedIcon sx={{ fontSize: 14, color: "#333" }} />
    </IconButton>
  </Box>
) : (
  <IconButton
    onClick={() => setFilterDrawerOpen(true)}
    sx={{
      border: "1px solid #C4C4C4",
      borderRadius: 1,
      width: 34,
      height: 34,
      backgroundColor: "white",
      color: "#5E5C5C",
      "&:hover": { backgroundColor: "#F2F2F2" },
    }}
  >
    <FilterAltIcon sx={{ fontSize: 22 }} />
  </IconButton>
)}

              </>
            )}
          </Box>
        </Box>



        {/* Show loading spinner for initial load/filter changes */}
        {loading && (
          <Box sx={{ height: "40vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress size={40} sx={{ color: "#006EC2" }} />
          </Box>
        )}

        {/* Show table content when not loading (either initial load or sorting) */}
        {!loading && (
          <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
            <Table size="small">
              <TableHead sx={{
                  whiteSpace: 'nowrap', // ✅ Prevent text wrap
   
      overflow: 'hidden',
  textOverflow: 'ellipsis',
              }}>
                <TableRow>
                  {columns.map((col) => (
                    <TableCell key={col.key} sx={{ ...HaederStyles, py: "6px", px: "2px" }}>
                      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        {col.label}
                        {col.key !== "action" && (
                          <IconButton onClick={() => handleSort(col.key)}>
                            {sortConfig.key === col.key ? (
                              sortConfig.direction === "asc" ? (
                                <NorthIcon sx={{ fontSize: "12px", }} />
                              ) : (
                                <SouthIcon sx={{ fontSize: "12px",  }} />
                              )
                            ) : (
                              <SouthIcon sx={{ fontSize: "12px",  }} />
                            )}
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
<TableBody>
  {paginatedRows.length === 0 ? (
    <TableRow>
      <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
           <Box sx={{ display: 'flex',flexDirection:"column" ,justifyContent: 'center', alignItems: 'center', height: 300 }}>
          <img src={emptypayment} alt="No Data" style={{ width: 200,  }} />
            <CustomText
    sx={{
      ...textStyles.h1,
      fontWeight: 500,
      fontSize: '16px',
      color: '#003149',
      pt:1,
    }}
  >
  {t('no_commission')}
  </CustomText>

        </Box>
      </TableCell>
    </TableRow>
  ) : (
    paginatedRows.map((row) => (
      <TableRow key={row.id} hover>
        <TableCell sx={{ ...DataStyles, pl: 2 }}>{row.id}</TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.companyName}</TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.batchId}</TableCell>
        <TableCell sx={DataStyles}>  {formatNumber(row.payoutAmount, true)}</TableCell>
        <TableCell sx={DataStyles}>{row.method}</TableCell>
        <TableCell sx={DataStyles}>{row.paymentDate}</TableCell>
        <TableCell sx={{ ...DataStyles, textAlign: "center" }}>{row.email}</TableCell>
        <TableCell sx={DataStyles}>
          <Box sx={{ pointerEvents: "none" }}>
            <StatusDropdown currentStatus={row.payoutStatus} />
          </Box>
        </TableCell>
        <TableCell sx={DataStyles}>
          <IconButton
            ref={(el) => {
              if (el) menuAnchorsRef.current[row.id] = el;
            }}
            onClick={() => {
              setAnchorEl(menuAnchorsRef.current[row.id]);
              setMenuRowId(row.id);
            }}
          >
            <MoreVertIcon fontSize="small" sx={{ fontSize: "22px" }} />
          </IconButton>
        </TableCell>
      </TableRow>
    ))
  )}
</TableBody>

            </Table>
          </TableContainer>
          
        )}
        
                                                 <Menu
                   sx={{fontSize:"15px",boxShadow:"none"}}
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={() => setAnchorEl(null)}

                    anchorOrigin={{
    vertical: 'bottom',
    horizontal: 'center',
  }}
  transformOrigin={{
    vertical: 'top',
    horizontal: 'center',
  }}
                    PaperProps={{
                    sx: {
                      // minWidth: 80,
                      // paddingY: 0.5,
                      // boxShadow:"none",
                      // border: '1px solid #E0E0E0',
                    },
                  }}
                  MenuListProps={{
                    sx: {
                      paddingY: 0,
                    },
                  }}
                >
                  <MenuItem    onClick={() => {
    setSelectedRow(selectedRowFromMenu); // ✅ same as icon onClick
    setAnchorEl(null); // ✅ close menu
    setMenuRowId(null); // ✅ cleanup
  }}
  sx={{fontSize:"14px",
                       fontFamily: 'Poppins, sans-serif',
                  }}>{t("common.view")}</MenuItem>
                </Menu>

             <Box sx={{ display: 'flex',flexWrap:"wrap", justifyContent: 'center', mt: 2 }}>
            <Pagination
  count={totalPages}
  page={page + 1}
  onChange={(e, value) => setPage(value - 1)}
  shape="rounded"
  color="primary"
  size="small"
  sx={{
    '& .MuiPaginationItem-root': {
      fontFamily: 'Poppins, sans-serif',
      fontSize: 13,
      fontWeight: 500,
    },
    '& .Mui-selected': {
      backgroundColor: '#E9F3FF',
      color: '#006EC2',
    },
  }}
/>
</Box>
      </Box>

      <RequestPayoutDrawer open={openDrawer} onClose={() => setOpenDrawer(false)} />
      <WalletDetails open={!!selectedRow} onClose={() => setSelectedRow(null)} selectedRow={selectedRow} />
      <FilterDrawer
        open={filterDrawerOpen}
        onClose={() => setFilterDrawerOpen(false)}
        initialFilters={filters}
        onApplyFilters={handleApplyFilters}
        onClearAllFilters={handleClearAllFilters}
      />
    </Box>
  );
};

export default ManagePayoutTable;














